// extracted by mini-css-extract-plugin
export default {"productGrid":"KZ-z","centerLink":"LZ-z","productSection":"MZ-z","item":"NZ-z","ctaButton":"OZ-z"};